import axios from 'axios'

export default {
    createLocationForUser(data) {
        return axios.post('/location/user', data)
    },

    createLocationForCompany(data) {
        return axios.post('/location/company', data, {
            headers: {
                'x-tenant-id': data.companyId,
            },
        })
    },

    deleteLocationForCompany(locationId, userId) {
        return axios.delete(`/location/company/${locationId}`, {
            headers: {
                'x-tenant-id': userId,
            },
        })
    },

    deleteLocationForUser(locationId) {
        return axios.delete(`/location/user/${locationId}`)
    },

    editLocationForUser(locationId, data) {
        return axios.put(`/location/user/${locationId}`, data)
    },

    editLocationForCompany(data) {
        return axios.put(`/location/company/${data.locationId}`, data, {
            headers: {
                'x-tenant-id': data.companyId,
            },
        })
    },
}
